// extracted by mini-css-extract-plugin
export default {"content":"RegistrationConfirmation_content__g5K40","realContent":"RegistrationConfirmation_realContent__FzEVV"};